<script>
import baseMixin from '@/mixins/baseMixin'
import { mapState } from 'vuex'
import HttpStatusCodes from '@/constants/api/HttpStatusCodes'
import config from '@/common/config'

export default {
  mixins: [baseMixin],

  data: () => ({
    onMessageListener: null,
  }),
  computed: {
    ...mapState({
      taskType: (state) => state.disputes.flyout.task.type,
      formUrl: (state) => state.disputes.flyout.task.formUrl,
      taskId: (state) => state.disputes.flyout.task.id,
      status: (state) => state.disputes.flyout.task.status,
    }),
    formAlreadySubmitted() {
      return this.status === HttpStatusCodes.NoContent
    },
  },
  beforeDestroy() {
    if (this.onMessageListener) {
      removeEventListener('message', this.handleOnMessage)
      this.onMessageListener = null
    }
  },
  mounted() {
    this.setupForms2MessageListener()
  },
  methods: {
    exitTasksDialog() {
      this.$emit('refreshTaskList')
      this.$store.commit('disputes/RESET_FLYOUT')
    },
    setupForms2MessageListener() {
      // Avoid duplicate listeners
      if (this.onMessageListener) return
      this.onMessageListener = this.handleOnMessage.bind(this)
      addEventListener('message', this.handleOnMessage)
    },
    async handleOnMessage(event) {
      const allowedOrigins = config.get('forms2.allowedOrigins').split(',')

      // Confirm message was sent from expected origin
      if (
        !allowedOrigins.some(
          (origin) => event.origin === origin || origin === '*'
        )
      )
        return

      if (
        Object.hasOwn(event.data, 'submission_type') &&
        event.data?.submitted === 'true'
      ) {
        this.exitTasksDialog()
      }
    },
  },
}
</script>

<template>
  <div class="embedded-form-iframe">
    <iframe
      v-if="formUrl && !formAlreadySubmitted"
      :src="formUrl"
      class="fill-height w-full"
      frameborder="0"
    ></iframe>
    <div
      v-if="formAlreadySubmitted"
      data-testid="form-already-submitted"
      class="d-flex flex-column align-center mt-10"
    >
      <v-icon size="120" color="primary">mdi-check-circle-outline</v-icon>
      <p class="text-h6 text-center mt-6">{{
        $t('dispute.task.alreadySubmittedText')
      }}</p>

      <v-btn
        width="240px"
        class="mt-4 py-6"
        color="primary"
        @click="exitTasksDialog"
        >{{ $t('dispute.task.taskButtonClose') }}</v-btn
      >
      <p v-if="taskId" class="text-subtitle text-center mt-4">{{ taskId }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.embedded-form-iframe {
  width: 100%;
  height: 99.55%;
}

.w-full {
  width: 100%;
}
</style>

<style>
.v-card__text:has(> .embedded-form-iframe) {
  overflow: hidden !important;
}
</style>
